export default "__VITE_ASSET__54c8f5a8__"